import React from 'react'
import {formatClassName} from '../../utils/global'
import {SolanaWalletPage} from '../pages/wallets/solana-wallet'
import styles from './wallet-layout.module.scss'

export const WalletLayout = () => <div className={formatClassName(styles, 'wallet-layout')}>
  <SolanaWalletPage />
</div>
